import simulatorTrainingEndUserDeclaration from 'modules/simulatorTrainings/common/slices/endUserDeclaration'
import simulatorTrainingInstructor from 'modules/simulatorTrainings/common/slices/instructor'
import simulatorTrainingStudent from 'modules/simulatorTrainings/common/slices/student'
import simulatorTrainingInstructorILSchedules from 'modules/simulatorTrainings/instructor/instructorLed/Schedules/slices/schedules'
import simulatorTrainingInstructorILSimulatorList from 'modules/simulatorTrainings/instructor/instructorLed/SimulatorList/slices/simulatorList'
import simulatorTrainingInstructorILSimulatorSheet from 'modules/simulatorTrainings/instructor/instructorLed/SimulatorSheet/slices/simulatorSheet'
import simulatorTrainingInstructorILTrainingDetails from 'modules/simulatorTrainings/instructor/instructorLed/TrainingDetails/slices/trainingDetails'
import simulatorTrainingInstructorSLExerciseList from 'modules/simulatorTrainings/instructor/studentLed/ExerciseList/slices/exerciseList'
import simulatorTrainingInstructorSLExerciseSheet from 'modules/simulatorTrainings/instructor/studentLed/ExerciseSheet/slices/exerciseSheet'
import simulatorTrainingInstructorSLSchedules from 'modules/simulatorTrainings/instructor/studentLed/Schedules/slices/schedules'
import simulatorTrainingInstructorSLTrainingDetails from 'modules/simulatorTrainings/instructor/studentLed/TrainingDetails/slices/trainingDetails'
import simulatorTrainingStudentILTrainingDetails from 'modules/simulatorTrainings/student/instructorLed/TrainingDetails/slices/trainingDetails'
import simulatorTrainingStudentSLTrainingDetails from 'modules/simulatorTrainings/student/studentLed/TrainingDetails/slices/trainingDetails'

const slices = {
  simulatorTrainingInstructor,
  simulatorTrainingStudentILTrainingDetails,
  simulatorTrainingStudentSLTrainingDetails,
  simulatorTrainingInstructorILSchedules,
  simulatorTrainingInstructorILSimulatorList,
  simulatorTrainingInstructorILSimulatorSheet,
  simulatorTrainingInstructorILTrainingDetails,
  simulatorTrainingStudent,
  simulatorTrainingInstructorSLExerciseList,
  simulatorTrainingInstructorSLExerciseSheet,
  simulatorTrainingInstructorSLSchedules,
  simulatorTrainingInstructorSLTrainingDetails,
  simulatorTrainingEndUserDeclaration,
}

export default slices
